import React from 'react';
import { map, isEmpty } from 'lodash';
import { useLumaBotFlowSnapshot } from 'ui-model';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import {
  SessionMessage,
  LumaBotFlowSessionLogLoading,
  LumaBotFlowSessionLogEmptyState,
  LumaBotFlowSessionLogErrorState,
} from './components';
import styles from './LumaBotFlowSessionLog.styles';

interface ILumaBotFlowSessionLog extends WithStyles<typeof styles> {
  flowId: string;
}

const LumaBotFlowSessionLog: React.FC<ILumaBotFlowSessionLog> = ({ flowId, classes }) => {
  const { data, isLoading, isError, isSuccess, refetch, isRefetching } = useLumaBotFlowSnapshot({
    flowId,
    showWholeSession: true,
  });
  const messageHistory = data?.response[0]?.messages || [];

  if (isLoading || isRefetching) return <LumaBotFlowSessionLogLoading />;
  if (isError) return <LumaBotFlowSessionLogErrorState handleRefetch={refetch} />;
  if (isSuccess && isEmpty(messageHistory)) return <LumaBotFlowSessionLogEmptyState />;

  return (
    <div className={classes.container}>
      {map(messageHistory, (message) => (
        <SessionMessage key={`${message.source}@${message.createdAt}`} message={message} />
      ))}
    </div>
  );
};

export default withStyles(styles)(LumaBotFlowSessionLog);
